const poolColors: any = [
     { 
        code: '#7CB5C7', 
        name: 'Azul' },
     { 
        code: '#F9EEDF', 
        name: 'Beige' },
     { 
        code: '#F8F9FA', 
        name: 'Blanco' },
     { 
        code: '#DEF1F6', 
        name: 'Celeste' },
     { 
        code: '#C2CACD', 
        name: 'Gris' },
     { 
        code: '#000000', 
        name: 'Negro' },
     { 
        code: '#C77C7C', 
        name: 'Rojo' },
     { 
        code: '#94C77C', 
        name: 'Verde' },
];

export { poolColors };
